// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* .content {\n  font-weight: bold;\n} */\n.v-list[data-v-ed286ec4] {\n  background: #171921;\n  border: 1px solid #4A4A4A;\n}\n[data-v-ed286ec4] .v-list-item__content {\n  color: white;\n}", ""]);
// Exports
module.exports = exports;
